import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StatusGraphState, STATUS_GRAPH_SLICE } from './status-graph.state';

const selectFeature = createFeatureSelector<StatusGraphState>(STATUS_GRAPH_SLICE);

export const selectStatusGraph = createSelector(selectFeature, (state) => state.statusGraph);

export const selectLoading = createSelector(selectFeature, (state) => state.loading);
